import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useMediaPlan = () => {
  const { campaignId: planId } = routerApi.useParams();

  const { data, isLoading, isError } = useQuery(
    MediaPlan.getPlanQueryOptions({
      urlParams: { planId },
    }),
  );

  return { data: data?.data?.items[0], isLoading, isError };
};
